<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>温馨提示</span>
      <img
        :src="fanhuiIcon"
        alt
        :class="$style.fanhui"
        @click="back"
      />
    </header>
    <main>
      <div :class="$style.content">
        <p>尊敬的玩家：</p>
        <p>您好，为保证您良好的游戏体验，进入游戏前，需要您仔细阅读<span @click="showArgument(0)">《用户服务协议》</span>和<span @click="showArgument(1)">《用户隐私保护协议》</span>，当您点击下方同意按钮时，代表您已理解并同意签署协议。</p>
      </div>
      <button @click="agreeArgument">我已同意，进入游戏</button>
    </main>
  </div>
</template>

<script>
import isFullScreen from '@/libs/business/fullScreen'
import { mapState } from 'vuex'

export default {
  name: "",
  props: [
  ],
  data() {
    return {
      fullScreen: '',
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  computed: {
    ...mapState({
      argumentType: state => state.user.argumentType
    })
  },
  methods: {
    showArgument(type) {
      this.$emit('showArgument', type);
    },
    agreeArgument() {
      this.$emit("agreeArgument");
    },
    back() {
      this.$emit('back')
    }
  },
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  @include common-window(true);
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.4rem 0.24rem;
    overflow-y: auto;
    line-height: .32rem;
    > p {
      > span {
        color: $primary-color;
      }
    }
    > button {
      @include common-button;
      margin-top: .6rem;
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 19px 12px;
      overflow-y: auto;
      line-height: 16px;
      > button {
        @include full-screen-button;
        margin-top: 30px;
      }
    }
    > iframe {
      width: 100%;
      height: calc(100% - 46px);
      background: #ffffff;
      border-radius: 50px 0 10px 10px;
      box-sizing: border-box;
    }
  }
}
</style>